module.exports = __webpack_public_path__ + "static/media/20.b175a1e9.jpg";